import React from 'react'

export const Row = (props) => <div className={"row " + props.className} style={props.style}>{props.children}</div>
export const Col = (props) => <div className={`col col-${props.n} ` + props.className} style={props.style}>{props.children}</div>

export const Box = (props) => <div style={{ padding: ( props.p || 2 ) * 0.5 + 'rem' , ...props.style}} className={"box " + props.className}>{props.children}</div>

//
// ─── FLEX ───────────────────────────────────────────────────────────────────────
//

export const Flex = (props) => {
    let classes = 
        ' flex' 
        + ( props.n != undefined ? ' flex-' + props.n : '' ) 
        + ( props.align != undefined ? ' align-' + props.align : '' )
        + ( props.justify != undefined ? ' justify-' + props.justify : '' )
        + ( props.direction != undefined ? ' direction-' + props.direction : '' )

    // console.log( classes )
    const style = {
        display : 'flex',
        flex : props.n || 'initial',
        alignItems : props.align || 'initial',
        justifyContent : props.justify || 'initial',
        flexDirection : props.direction || 'row',
        ...props.style
    }

	return (

		<div ref={props.setRef} className={ ( props.className ? props.className : '') + ' ' + classes} id={props.id}  style={props.style} onMouseDown={props.onMouseDown}>
            {props.children}
        </div>

	)
}

export const InlineBlock = (props) => {
    
    const style = {
        display : 'inline-block',
        ...props.style
    }

	return (

		<div className={props.className} id={props.id}  style={style}>
            {props.children}
        </div>

	)
}


// WEBPACK FOOTER //
// ./src/components/layout/index.js